<!--  -->
<template>
  <div>
    <div class="band_box">
      <div>
        <!-- <div class="choses_box">
          <div v-if="arrs.length === arr.length" @click="whole">
            取消全选
          </div>
          <div v-else @click="whole">
            全选
          </div>
        </div> -->
        <!-- <div class="choses_box">
          <div v-if="fullName" @click="whole">
            取消全选
          </div>
          <div v-else @click="whole">
            全选
          </div>
        </div> -->
        <div class="serch_box">
          <el-input v-model="objr.strategy_name" placeholder="请输入要搜索的策略号" style="width:180px" />
          <el-button type="primary" class="search_icon" icon="el-icon-search" @click="secahclkick" />
        </div>

        <div v-for="item,index in arr" :key="index" :class="[item.tips?'have ':'']" class="choose_block">
          <!-- {{ item.canChecked }} -->
          <!-- <div v-if="item.canChecked === 9" class="select_boxone" /> -->
          <div class="select_box" :class="[item.tips?'choose_blockr':'']" @click="itenclick(item,index)" />
          <span>{{ item.strategyName }}</span>
        </div>

        <pagination-right
          style="padding:0px;margin-top:20px"
          :total="total"
          @size-change="fetchPageSize"
          @current-change="fetchCurrentPage"
        />

      </div>
      <div class="rigboxr">
        <div class="choiceofficialaccount">选中的策略</div>
        <!-- <div v-for="itemr,index in arrs" :key="index" class="select_spacing" @click="rightclick(itemr.id,index)">
          {{ itemr.name }}
        </div> -->
        <!-- closable -->
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-right:10px;margin-bottom:5px"

          :type="itemr.type"
          @close="rightclick(itemr.id,index)"
        >
          {{ itemr.name }}
        </el-tag>
      </div>
    </div>
    <div class="que_box">
      <el-button type="primary" @click="quebtn">确定</el-button>
    </div>
  </div>
</template>

<script>
import { /* strategybindaccout*/ /* unbindaccountlist,*/ listforOfficialbind, strategybindaccout } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      searchvalue: null,
      searchTopicLoading: false, // 搜索锁
      topicList: [], // 公众号临时绑定数组
      options: [], // 公众号列表数组
      value1: [], // 公众号多选完成集合数组
      id: null, // 点击保存的id
      tableData: [], // 表格数组
      obj: { // 表格参数
        page: 1,
        pageSize: 10,
        templateName: null
      },
      arr: [],
      arrs: [],
      arrsw: [],

      obr: {
        strategyPreviewNo: null,
        page: 1,
        pageSize: 10,
        accountName: null
      },

      total: null,

      objr: {
        page: 1,
        pageSize: 10,
        platformId: null,
        strategyType: null,
        strategyNo: null,
        appId: null,
        strategy_name: null
      }

    }
  },
  computed: {
    // fullName: function() {
    //   return this.arr.filter((num) => {
    //     return num.canChecked !== 9
    //   }).every(function(item) {
    //     return item.tips === true
    //   })
    // }
  },
  created() {
    // this.allpolicylist()
  },
  mounted() {

  },
  methods: {

    // async nubindlist() {
    //   const data = await unbindaccountlist(this.obr)
    //   console.log(data.data.list)
    // },
    secahclkick() {
      // if (this.obr.accountName === null || this.obr.accountName === '') {
      //   this.$message.error('请输入关键字')
      //   return
      // }
      this.obr.page = 1
      this.allpolicylist()
    },
    async allpolicylist() {
      const data = await listforOfficialbind(this.objr)
      console.log('policylist', data.data.list)
      data.data.list = this.convertToHump(data.data.list)
      this.total = data.data.total
      data.data.list.forEach((item) => {
        item.tips = false
        if (this.arrs.length !== 0) {
          if (this.arrs[0].id === item.strategyNo) {
            item.tips = true
          }
        }
      })
      this.arr = data.data.list
    },

    // async secahclkickr() {
    //   if (this.obr.accountName === '') {
    //     this.obr.accountName = null
    //   }

    //   const data = await unbindaccountlist(this.obr)
    //   console.log('data', data.data)
    //   this.total = data.data.total
    //   data.data.list.forEach((item) => {
    //     item.tips = false
    //   })
    //   this.arr = data.data.list
    //   this.arr.forEach((item) => {
    //     // console.log('item', item)
    //     this.arrs.forEach((items) => {
    //       if (items.id === item.appId) {
    //         console.log('items', item)
    //         item.tips = true
    //       }
    //     })
    //   })
    // },

    // 点击确定
    async quebtn() {
      const data = await strategybindaccout({
        app_ids: [this.objr.appId],
        strategy_no: this.arrs[0].id
      })
      this.$message({
        message: '绑定策略成功',
        type: 'success'
      })
      this.$emit('onbangaccout')
      console.log('data', data)
    },

    itenclick(item, index) {
      this.arr.forEach((item) => {
        item.tips = false
      })
      item.tips = true
      console.log('item', item)
      this.arrs = []
      this.arrs.push({ id: item.strategyNo, name: item.strategyName })
      // item.tips = !item.tips
      // if (item.tips) {
      //   this.arrs.push({ id: item.appId, name: item.accountName })
      // } else {
      //   const index = this.arrs.findIndex((items) => {
      //     return items.id === item.appId
      //   })
      //   this.arrs.splice(index, 1)
      // }
    },

    // whole() {
    //   if (this.fullName === true) {
    //   // if (this.arrs.length === this.arr.length) {
    //     console.log('666')
    //     this.arr.forEach((item) => {
    //       if (item.canChecked === 1) {
    //         item.tips = false
    //         const index = this.arrs.findIndex((items) => {
    //           return items.id === item.appId
    //         })
    //         this.arrs.splice(index, 1)
    //       }
    //     })
    //   } else {
    //     console.log('777')
    //     this.arr.forEach((item) => {
    //       if (item.canChecked === 1) {
    //         item.tips = true
    //         this.arrs.map(re => re.id).includes(item.appId) || this.arrs.push({ id: item.appId, name: item.accountName })
    //       }
    //     })
    //     // this.arr.forEach((item) => {
    //     //   this.arrs.includes(item.id) || this.arr.push(item.id)
    //     // })
    //   }
    // },
    rightclick(id, index) {
      console.log(id, index)
      this.arrs.splice(index, 1)
      this.arr.findIndex((items) => {
        if (items.appId === id) {
          items.tips = false
        }
      })
    },
    sendbind(item) {
      console.log('id', item)
      this.objr.platformId = item.platformId
      this.objr.appId = item.appId
      this.allpolicylist()
    },
    // send(e) {
    //   this.id = e
    //   this.obr.strategyNo = e
    //   this.secahclkickr()

    //   console.log('send', e)
    // },
    // 分页
    fetchPageSize(e) {
      this.objr.pageSize = e
      this.allpolicylist()
    },
    fetchCurrentPage(e) {
      this.objr.page = e
      this.allpolicylist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
/* @import url(); 引入css类 */
.allbox{
  padding: 30px;
}
.que_box{
  margin-top: 20px;
}
.have{
  color: #409eff;
}
.serch_box{
  display: flex;
  margin-bottom: 10px;
}
.search_icon{
  margin-left: 10px;
}
.band_box{
  display: flex;
}
.choses_box{
  margin-bottom: 10px;
}
.select_box{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.select_boxone{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}
.choose_block{
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.choose_blockr{
  background: #409eff;
}
.rigboxr{
  margin-left: 85px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 520px;
  overflow: hidden;
  overflow-y: scroll;
}
:-webkit-scrollbar {
     width: 0 !important;
}
::-webkit-scrollbar {
     width: 0 !important;height: 0;
  }
.choiceofficialaccount{
  margin-bottom: 10px;
}
.select_spacing{
  margin-bottom: 5px;
}
</style>
